// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2gcGh","footer":"ModalError_footer__3Jwyt"};